import { CarouselItemId } from '@homex/se-widget-flow-types';
import { useSelector } from 'react-redux';
import { useTheme } from 'styled-components/macro';

import { CarouselItemAddressCorrectionBottom } from 'components/CarouselItemAddressCorrectionBottom';
import { IState } from 'typings';
import { tryGetFlowCarouselItem } from 'utils/tryGetFlowCarouselItem';

export const CAROUSEL_ITEM_ID = CarouselItemId.RepairAddressCorrection;

export const CarouselItemAddressRepairCorrectionBottom = () => {
  const { flowCarouselItem } = useSelector((state: IState) => ({
    flowCarouselItem: tryGetFlowCarouselItem(
      state.client.flow,
      CAROUSEL_ITEM_ID,
    ),
  }));
  const theme = useTheme();

  let destinationId;

  if (flowCarouselItem) {
    destinationId = flowCarouselItem.options.destinations.next;
  } else {
    destinationId = theme.schedulePreferenceEnabled
      ? CarouselItemId.SchedulePreference
      : CarouselItemId.ScheduleCalendarRepair;
  }

  return <CarouselItemAddressCorrectionBottom destinationId={destinationId} />;
};
